import React from "react";
import { Text, Box, Flex } from "rebass";
import {Route, useRouteMatch, Switch} from "react-router-dom";
import moment from "moment";
import { Patient } from "../../Types";
import {NavBar, HomeIcon, LabeledText, HomeActivationText, OverviewHeader} from "../../Components";
import {
  MeasurementContainer,
  SettingsContainer,
  HomeContainer,
  ConfigurationContainer,
  ResultsContainer, PerimetryTest,
} from "./SubViews";
import {useWindowWidth, useWindowHeight} from "@react-hook/window-size";
import {GamesSettingsContainer} from "./SubViews/BV/GamesSettings/GamesSettingsContainer";

const navOptions = [
  // {
  //   path: "",
  //   label: "Home",
  // },
  {
    path: "/configuration",
    label: "Configuration",
  },
  {
    path: "/measurements",
    label: "Measurements",
  },

  // {
  //   path: "/settings",
  //   label: "Game Settings",
  // },
  {
    path: "/results",
    label: "Results"
  },
  // {
  //   path: "/games",
  //   label: "Game Settings"
  // },
  // {
  //   path: "/perimetry",
  //   label: "Perimetry Test"
  // }
];

export const PatientsOverview: React.FC<{
  patient?: Patient | null;
}> = ({ patient }) => {
  const match = useRouteMatch();

  return (
      <div id="PatientsOverview" style={{width: "100%", height: "100vh", overflow: "auto"}} data-tour="patientOverview">
        <Box width="100%" padding={"15px"}>
          
          {!patient ? (
            <div>
              <Flex alignItems="center" justifyContent="right">
                <OverviewHeader/>
              </Flex>
              <Flex paddingTop={2} paddingLeft={"2px"}>
                <Text fontSize={[5]}>Select a patient to get started</Text>
              </Flex>
            </div>
          ) : (
              <div>
                <Flex alignItems="center" justifyContent="space-between">
                  <Text color="darkBlue" fontWeight="bold" fontSize={[5, 5]}>
                    {patient.user_name.length < 60? patient.user_name : patient.user_name.slice(0, 60) + "..."}
                  </Text>
                  <OverviewHeader/>
                </Flex>

                <Flex paddingTop={2} paddingLeft={"2px"}>
                  <LabeledText label={"Patient ID:"} value={'#' + patient.clinic_user_id} paddingLeft={1} paddingRight={3}/>
                  <LabeledText label={"Vivid Vision ID:"} value={'#' + patient.clinic_user_id} paddingLeft={1} paddingRight={3}/>
                  <LabeledText label={"DOB:"} value={moment.unix(+patient.dob).format("YYYY/MM/DD")} paddingLeft={1} paddingRight={3}/>
                  <LabeledText label={"Last Activity:"} value={+patient.last_played !== 0 ? moment.unix(+patient.last_played).fromNow() : "Never"} paddingLeft={1} paddingRight={3}/>
                  <HomeActivationText home_activation_code={patient.home_activation_code}/>
                </Flex>

                <NavBar
                    navOptions={navOptions.map((option) => ({
                      ...option,
                      path: `${match.url}${option.path}`,
                    }))}
                />
                <Box
                    css={{ borderRadius: "15px" }}
                    backgroundColor="muted"
                    padding={2}
                >
                  <Switch>
                    <Route exact path={`${match.path}`}>
                      <HomeContainer patient={patient} />
                    </Route>
                    <Route path={`${match.path}/configuration`}>
                      <ConfigurationContainer patient={patient} />
                    </Route>
                    <Route path={`${match.path}/measurements`}>
                      <MeasurementContainer patient={patient} />
                    </Route>
                    <Route path={`${match.path}/settings`}>
                      <SettingsContainer patient={patient} />
                    </Route>
                    <Route path={`${match.path}/results`}>
                      <ResultsContainer patient={patient} />
                    </Route>
                    <Route path={`${match.path}/games`}>
                      <GamesSettingsContainer patient={patient} />
                    </Route>
                    <Route path={`${match.path}/perimetry`}>
                      <PerimetryTest patient={patient} />
                    </Route>
                  </Switch>
                </Box>
              </div>
          )}
        </Box>
      </div>
  );
};
